export default __webpack_public_path__ + "assets/item2.16f1d142ea6015dbf0f3a7674a21e5af.png";